"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitleRow = exports.StyledTitle = exports.StyledStagesWrapper = exports.StyledMainTitle = exports.StyledDescription = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var StyledTitle = exports.StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledTitle",
  componentId: "sc-nf9ela-0"
})(["font-weight:500;font-size:22px;color:", ";line-height:26px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackBase;
});
var StyledMainTitle = exports.StyledMainTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledMainTitle",
  componentId: "sc-nf9ela-1"
})(["font-weight:500;font-size:22px;color:", ";line-height:26px;padding-left:11px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackBase;
});
var StyledDescription = exports.StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledDescription",
  componentId: "sc-nf9ela-2"
})(["font-size:15px;line-height:18px;color:", ";margin:20px 16px 0px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackLight;
});
var StyledTitleRow = exports.StyledTitleRow = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledTitleRow",
  componentId: "sc-nf9ela-3"
})(["display:", ";flex-direction:row;align-items:center;margin-bottom:", ";"], function (props) {
  return props.isCollapsed ? 'flex' : 'inline';
}, function (props) {
  return props.isCollapsed ? '16px' : 0;
});
var StyledStagesWrapper = exports.StyledStagesWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledStagesWrapper",
  componentId: "sc-nf9ela-4"
})(["margin-top:34px;display:flex;flex-direction:row;padding:", ";"], function (props) {
  return props.isMobile ? '0px' : '8px 16px';
});